import React from "react";
import { addElement } from "../../../actions/CreateSiteActions/createSiteActions";
import { connect } from "react-redux";
import PeoplePicker from "../../formFields/PeoplePicker";
import {
  ADD_MEMBERS,
  ADD_PSM_PURPOSE,
  //ADD_CHRD_COMMUNITY,
  ADD_PROJECT_SPECIFIC_MEMBERS,
  ADD_STANDARD_MEMBERS,
} from "../../../actions/types";
import InfoTooltip from "../../formFields/InfoTooltip";
import { Checkbox } from "@fluentui/react";
import RequiredTextField from "../../formFields/RequiredTextField";

class Members extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //chrdCommunity: true,
      projectSpecificMembers: false,
      standardMembers: true,
      purpose: "",
    };
  }
  _onSelectedUser = (items) => {
    this.props.addMember(items);
  };

  handleSelection = (key, ev, checked) => {
    // if (key === "chrdCommunity" && checked) {
    //   this.setState({
    //     //chrdCommunity: true,
    //     projectSpecificMembers: false,
    //   });
    if (key === "standardMembers" && checked) {
      this.setState({
        standardMembers: true,
        projectSpecificMembers: false,
      });
      //this.props.addChrdCommunity(true);
      this.props.addStandardMembers(true);
      this.props.addProjectSpecificMembers(false);
    } else if (key === "projectSpecificMembers" && checked) {
      this.setState({
        //chrdCommunity: false,
        standardMembers: false,
        projectSpecificMembers: true,
      });
      //this.props.addChrdCommunity(false);
      this.props.addStandardMembers(false);
      this.props.addProjectSpecificMembers(true);
    } else {
      this.setState({ [key]: false });
      //if (key === "chrdCommunity") this.props.addChrdCommunity(false);
      if (key === "standardMembers") this.props.addStandardMembers(false);
      if (key === "projectSpecificMembers")
        this.props.addProjectSpecificMembers(false);
    }
  };

  onWriteEvent = (event) => {
    this.setState({ purpose: event.target.value });
    this.props.addPsmPurpose(event.target.value);
  };

  render() {
    console.log("template:", this.props.template);
    return this.props.template && this.props.template.id === 6 ? (
      <div className="wizard-inside-third" style={{ height: "unset" }}>
        <div className="item-Owner">
          Members
          <InfoTooltip content="The members will only have access to the “General” team channel, but any of the owners can later assign them access to private channels if needed." />
        </div>
        <div className="checkbox-group-horizontal">
          <Checkbox
            label="Standard Members"
            checked={this.state.standardMembers}
            onChange={this.handleSelection.bind(this, "standardMembers")}
            className="checkbox-group-confirm"
          />
          <Checkbox
            label="Project Specific Members"
            checked={this.state.projectSpecificMembers}
            onChange={this.handleSelection.bind(this, "projectSpecificMembers")}
            className="checkbox-group-confirm"
          />
        </div>

        {this.state.standardMembers && (
          <div>
            <PeoplePicker
              defaultUsers={this.props.member}
              onSelectedUsers={this._onSelectedUser}
            />
          </div>
        )}

        {this.state.projectSpecificMembers && (
          <div>
            <PeoplePicker
              defaultUsers={this.props.member}
              onSelectedUsers={this._onSelectedUser}
            />
            <div className="item-title-rdarchive">
              Reason for Restricted Access
            </div>
            <label>
              <RequiredTextField
                name="Purpose"
                onChange={this.onWriteEvent}
                value={this.state.purpose}
                validationResult={true}
                multiline
                rows={10}
              />
            </label>
          </div>
        )}
      </div>
    ) : (
      <div className="wizard-inside-third" style={{ height: "unset" }}>
        <div className="item-Owner">Members</div>
        <PeoplePicker
          defaultUsers={this.props.member}
          onSelectedUsers={this._onSelectedUser}
        />
      </div>
    );
  }
}

// Approver.propTypes = {
//     addApprover: PropTypes.func.isRequired,
//     approver: PropTypes.object,
//     currentUser: PropTypes.object,
//     manager: PropTypes.object,
//     owner: PropTypes.object,
// }

const mapActionToProp = (dispatch) => ({
  addMember: (element) => {
    dispatch(addElement(ADD_MEMBERS, element));
  },
  addPsmPurpose: (value) => dispatch(addElement(ADD_PSM_PURPOSE, value)),
  addProjectSpecificMembers: (value) =>
    dispatch(addElement(ADD_PROJECT_SPECIFIC_MEMBERS, value)),
  addStandardMembers: (value) =>
    dispatch(addElement(ADD_STANDARD_MEMBERS, value)),
  //addChrdCommunity: (value) => dispatch(addElement(ADD_CHRD_COMMUNITY, value)),
});

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  member: state.newSite.Members,
  possibleWarning: state.wizard.nextStepRequested,
  template: state.newSite.Template,
});

export default connect(mapStateToProps, mapActionToProp)(Members);



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step5/Members.js